export const RateDetail = {
  "request_id": "RT1608544133865987",
  "error_code": 0,
  "error_msg": "",
  "data": {
      "id": "1-922134861897",
      "thirdparty_type": 1,
      "status": 7, //状态  0:双方待评价  1:房东待评、房客已评  2：房东已评、房客待评  3:待回复  7:已完成
      "host_comment": { //可空，房东未评时为null
          "score": 5, // 房东评分
          "content": "素质很高的客人，希望再次为您服务。",// 房东评论内容
          "time": "2020-12-14 00:00:00"// 房东评论时间
      },
      "guest_comment": {//可空，房客未评时为null
          "score": 4.7,
          "content": "非常好的入住体验，感谢热情招待。",
          "photos": [
              "https://pic.tujia.com/upload/comment/day_201215/thumb/202012151541589081_570_420.jpg",
              "https://pic.tujia.com/upload/comment/day_201215/thumb/202012151541589081_570_420.jpg",
              "https://pic.tujia.com/upload/comment/day_201215/thumb/202012151541589081_570_420.jpg",
              "https://pic.tujia.com/upload/comment/day_201215/thumb/202012151541589081_570_420.jpg",
              "https://pic.tujia.com/upload/comment/day_201215/thumb/202012151541589081_570_420.jpg",
          ],
          "time": "2020-12-14 00:00:00"
      },
      "host_reply": {//可空，房东未回复为null
          "content": "感谢信任，欢迎下次光临。",
          "time": "2020-12-14 00:00:00"
      },
      "remain_days": 0 //剩余可评论天数，"已完成"时为0
  }
}